import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';

import Icon from 'src/common/components/icons/Icon';
import MaterialIcon from 'src/common/components/icons/MaterialIcon';
import { isAppIconId } from 'src/common/components/icons/iconPicker';
import { materialIconIdFromAttr } from 'src/common/components/icons/materialIconRegistry';

interface IconPickerTriggerButtonProps extends Omit<IconButtonProps, 'onClick'> {
  /** Current icon id (custom name or `material:IconName`). */
  value?: string;
  onOpen: () => void;
  /** When `choose`, always shows AutoAwesome; when `preview`, shows the selected icon. */
  variant?: 'choose' | 'preview';
  previewFontSize?: string;
  stopPropagation?: boolean;
}

export default function IconPickerTriggerButton({
  value,
  onOpen,
  variant = 'preview',
  previewFontSize = '1.25rem',
  size = 'small',
  stopPropagation = false,
  ...iconButtonProps
}: IconPickerTriggerButtonProps) {
  const previewIcon = isAppIconId(value ?? '') ? value : null;
  const previewMaterialIconId = materialIconIdFromAttr(value ?? '');
  const showPreview = variant === 'preview' && (previewIcon || previewMaterialIconId);

  return (
    <IconButton
      size={size}
      onClick={event => {
        if (stopPropagation) {
          event.stopPropagation();
        }
        onOpen();
      }}
      {...iconButtonProps}
    >
      {showPreview && previewMaterialIconId ? (
        <MaterialIcon iconId={previewMaterialIconId} sx={{ fontSize: previewFontSize }} />
      ) : showPreview && previewIcon ? (
        <Icon icon={previewIcon} sx={{ fontSize: previewFontSize }} />
      ) : (
        <AutoAwesomeIcon fontSize="small" />
      )}
    </IconButton>
  );
}
